// import * as album from './album'
import * as user from './user'
import * as flock from './flock'
import * as comment from './comment'
import * as post from './post'
import * as upload from './upload'
import * as editorPush from './editor-push'
// import * as balance from './balance'

export default {
  flock,
  user,
  comment,
  post,
  upload,
  editorPush
}
